<template>
    <div id="member" class="wrapper-fixed">
        <div class="action-bar-wrapper">
            <el-col :span="24" class="action-bar">
                <el-button type="primary" size="medium" @click="addStaffVisible=true">添加</el-button>
            </el-col>
        </div>

        <!-- 列表 -->
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
                prop="name"
                label="单位名称"
                show-overflow-tooltip
                width="250">
                <template slot-scope="scope" v-if="scope.row.unit_info">
                    <div style="whiteSpace:nowrap;overflow:hidden;textOverflow:ellipsis;width:100%;">{{scope.row.unit_info.name}}</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="bind_user_num"
                width="150"
                label="绑定用户数量">
            </el-table-column>
            <el-table-column
                prop="created_at"
                width="150"
                show-overflow-tooltip
                label="绑定时间">
            </el-table-column>
            <el-table-column label="操作" width='143'>
                <template slot-scope="scope">
                  <el-button type="danger" size="mini" @click="removeBind(scope.row.id)">解除绑定</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-col :span="24" class="footer-bar">
			<div class="page-code">
				<el-pagination
					background
					:page-size="16"
					layout="prev, pager, next"
					:total="totalPage"
					@current-change="pageChange"
						>
				</el-pagination>
			</div>
    </el-col>
    <!-- 列表end -->

        <!-- 添加弹窗 -->
		<el-dialog title="添加" :visible.sync="addStaffVisible" @close="initData">
            <el-form>
                <el-form-item label="添加" label-width="100px">
                    <el-select
                        v-model="executor"
                        filterable
                        remote
                        :loading="loading"
                        placeholder="请输入服务商名称"
                        @change="getExecutor"
                        :remote-method="searchName"
                        size="medium"
                            >
                        <div v-if="vipList.length!=0">
                            <el-option
                            v-for="(item) in vipList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            <template >
                                <div style="display:flex"><img :src="item.logo_url" style="width:30px;border-radius:50%;height:30px;object-fit:cover" alt="">&nbsp;&nbsp;&nbsp;{{item.name}}&nbsp;&nbsp;&nbsp; </div>
                            </template>
                        </el-option>
                        </div>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="setCircleAdmin">添加</el-button>
			</div>
		</el-dialog>
        <!-- 添加弹窗end -->



    </div>
</template>
<script>
export default {
    name:'member',
    data() {
        return {
            id:'',
            addStaffVisible:false,//弹窗状态
            searchText:'',


            vipList:[],
            executor:'',
            loading:false,

            tableData: [{}],
            page:1,
            totalPage:0
        }
    },
    watch: {

    },
    methods: {
        search(){
            this.page=1;
            this.getBindPackageMemberUnitList()
        },
        async getBindPackageMemberUnitList(){
            //获取列表
            let params={
                page:this.page,
                limit:16,
                vip_package_id:this.id,
                keyword:this.searchText
            }
            let res=await this.$api.getBindPackageMemberUnitList(
                params);
            if(res.data.level=='success'){
                this.tableData=res.data.data;
                this.totalPage=res.data.page_info.total;
            }
        },
        pageChange(e){
			//翻页
			this.page=e;
			this.getBindPackageMemberUnitList();
        },
        async removeBind(id){
            //解绑we
            let judge=null;
            let tit='解除绑定该单位?';
            try {
              judge=  await this.$confirm(tit, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
                })
            } catch (error) {
                judge='cancel'
            }
            if(judge=='confirm'){
                this.UnitUntieVipPackage(id)
            }
            console.log(judge)
        },
        async UnitUntieVipPackage(id){
            let res=await this.$api.UnitUntieVipPackage({id:id})
            if(res.data.level=='success'){
                this.$message.success(res.data.message);
                this.getBindPackageMemberUnitList();
            }else{
                this.$message.error(res.data.message);
            }
        },

        getExecutor(e){
            this.executor=e;
		    },
		async searchName(searchText){
			//搜索单位名
			this.loading=true;
            let params={
                page:this.page,
                limit:999,
                keyword:searchText,
                is_member_unit:1
            }
            let res=await this.$api.getUnitList(params);
			if(res.data.level=='success'){
                this.vipList=res.data.data
			}
			this.loading=false
        },
        async setCircleAdmin(){
            let params={
                unit_id:this.executor,
                vip_package_id:this.id
            }
            let res = await this.$api.vipPackageBindUnit(params);
            if(res.data.level=='success'){
                this.$message({
                    type:'success',
                    message:res.data.message
                })
                this.addStaffVisible = false
                this.getBindPackageMemberUnitList();
            }else{
                this.$message({
                    type:'error',
                    message:res.data.message
                })
            }
        },
        toCustomer_detail(id){
            this.$router.push({name:'Customer_detail',query:{id:id}})
        },
        initData(){
            this.executor=''
        }

    },
    mounted() {
        this.id=this.$route.query.id
        this.getBindPackageMemberUnitList()
    },
}
</script>
<style lang="scss" scoped>
    .screen{
          margin-top: -10px !important;
      }
      .action-bar-wrapper{
          position: sticky;
            z-index: 1;
            top:-10px;
      }
    .action-bar{
			background-color: #f2f2f2;

			height: 60px;
			margin: 10px 0px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			padding-left: 20px;
			.action-bar-input{
				width: 250px;
				margin-right: 14px;
      }
      .task-form-text{
				color: #666666;
			}
		}
		.el-table-style{
			width: 100%;
			border: 1px solid #f2f2f2;
		}
		.footer-bar{
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: #f2f2f2;
			padding: 8px;
			margin: 10px 0px;
			box-sizing: border-box;
		}
		.dialog-footer{
			text-align: center;
		}
		.executorList{
			display: flex;
			flex-wrap: wrap;
			div{
				margin:10px;
				border:1px solid #eee;
				border-radius: 5px;
				padding:5px 10px;
			}
		}
</style>



// WEBPACK FOOTER //
// src/pages/operation/meal_bind.vue